export default "__VITE_ASSET__CNR_MAug__"